export default "__VITE_ASSET__acb06a01__"